<template>
  <div class="h-full">
    <div ref="container" class="relative">
      <w-select
          v-if="defaultValue"
          :style="{width:'250px'}"
          class="mb-4"
          size="small"
          :defaultValue="defaultValue"
          @change="handleChangeType"
          :popup-container="container"
      >
        <w-option v-for="item in optionsCollection">{{ item }}</w-option>
      </w-select>
    </div>
    <Vchart class="chart" :options="options" v-if="defaultValue"></Vchart>
    <div class="h-full flex items-center" v-else>
      <w-empty description="暂无合适的可视化视图"></w-empty>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue'
import Vchart from '/@common/components/chart/index.vue'
import {advisorEchartsMap} from "./config";
import {getChartType} from "./types";
import {customizeAdvisor, getVisAdvices} from "../advisor/pipline";
import {Advice} from '@antv/ava';
import {compact, concat, uniq} from 'lodash';
import {customCharts} from "../charts";

const options = ref({})
const defaultValue = ref('')
const optionsCollection = ref<any[]>([])
const allAdviceData = ref<Advice[]>([])
const container = ref(null)

const props = defineProps({
  data: {
    type: Array,
    default: () => []
  },
  type: {
    type: String,
    default: ''
  }
})

onMounted(() => {
  const advisorConfig = {
    charts: customCharts,
    scopeOfCharts: {
      // 排除面积图
      exclude: ['area_chart', 'stacked_area_chart', 'percent_stacked_area_chart'],
    },
  };
  const advisor = customizeAdvisor(advisorConfig);

  const avaAdvices = getVisAdvices({
    data: props.data,
    myChartAdvisor: advisor,
  });

  const getMergedAdvices = (avaAdvices: Advice[]) => {
    if (!advisor) return [];
    const filteredAdvices = avaAdvices;
    const allChartTypes = uniq(
        compact(
            concat(
                getChartType(props.type),
                avaAdvices.map((item) => item.type),
            ),
        ),
    );
    return allChartTypes
        .map((chartTypeItem) => {
          const avaAdvice = filteredAdvices.find((item) => item.type === chartTypeItem);
          // 如果在 AVA 推荐列表中，直接采用推荐列表中的结果
          if (avaAdvice) {
            return avaAdvice;
          }
          // 如果不在，则单独为其生成图表 spec
          const dataAnalyzerOutput = advisor.dataAnalyzer.execute({data: props.data});
          if ('data' in dataAnalyzerOutput) {
            const specGeneratorOutput = advisor.specGenerator.execute({
              data: dataAnalyzerOutput.data,
              dataProps: dataAnalyzerOutput.dataProps,
              chartTypeRecommendations: [{chartType: chartTypeItem, score: 1}],
            });
            if ('advices' in specGeneratorOutput) return specGeneratorOutput.advices?.[0];
          }
        })
        .filter((advice) => advice?.spec) as Advice[];
  };
  // 合并模型推荐的图表类型和 ava 推荐的图表类型
  const allAdvices = getMergedAdvices(avaAdvices);
  allAdviceData.value = allAdvices
  if (allAdvices.length === 0) return
  if (!advisorEchartsMap[allAdvices[0].type]) return;
  defaultValue.value = allAdvices[0].type
  optionsCollection.value = allAdvices.map(item => item.type)
  options.value = advisorEchartsMap[allAdvices[0].type](allAdvices[0])
})

const handleChangeType = (value) => {
  const data = allAdviceData.value.find(item => item.type === value)
  options.value = advisorEchartsMap[value](data)
}
</script>

<style scoped lang="scss">
.chart {
  height: 300px !important;
}
</style>